import React from 'react';

interface BannerItemProps {
  image: string;
  title: string;
  description?: string;
  buttonText?: string;
  buttonLink?: string;
  itemIndex?: number; // Добавлен индекс элемента для применения уникальных стилей
}

function BannerItem({ image, title, description, buttonText, buttonLink, itemIndex }: BannerItemProps) {
  // Условные стили для второго и третьего элементов
  const imageStyle =
    itemIndex === 2
      ? "md:h-[60%] h-[75%] bottom-0 right-0"
      : itemIndex === 3
      ? "md:h-[50%] h-full bottom-0 right-0"
      : "h-full right-0 md:top-0 bottom-0";

  const titleStyle = itemIndex === 2 ? "" : "max-w-[250px] md:max-w-[320px]";

  return (
    <div className="relative w-full h-full bg-[#FFE5E5] rounded-xl overflow-hidden flex">
      {/* Изображение */}
      <img
        src={image}
        alt={title}
        className={`absolute ${imageStyle} w-auto max-w-none`}
      />
      {/* Содержимое баннера */}
      <div className="relative z-10 flex flex-col p-4 md:p-10  justify-between">
        <div>
          <h2 className={`${itemIndex === 2 || itemIndex === 3 ? "md:text-xl text-base" : "md:text-4xl text-base"} font-bold ${titleStyle} text-black/90`}>
            {title}
          </h2>
          {description && (
            <p className={`text-black/50 mt-4 ${itemIndex === 2 || itemIndex === 3 ? "md:text-base text-sm max-w-[210px] text-bold" : "md:text-2xl text-sm md:max-w-[340px] max-w-[250px]"}`}>
              {description}
            </p>
          )}
        </div>
        {buttonText && buttonLink && (
          <a
            href={buttonLink}
            className="md:px-3 md:py-4 px-2 py-2 bg-[#FFFFFF] md:text-2xl text-xs text-[#2C2C2C] rounded hover:bg-[#000000]/20 mt-2"
            style={{ width: "fit-content" }}
          >
            {buttonText}
          </a>
        )}
      </div>
    </div>
  );
}

export default BannerItem;
